export default "/signup/_next/static/chunks/fonts/jerry-mini-20c4efcbd4ff28ec35529c3dc8f91319.woff2";